export default {"src":"/_next/static/media/chat-2.c6f8893d.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};